import CustomerServiceChat from './CustomerServiceChat.vue';
import CustomerServiceChatList from './CustomerServiceChatList.vue';
export default {
  CustomerServiceChatList,
  CustomerServiceChat,
};
